module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAQlBMVEUAAAD1aE71Zkz0Z032bVL0Zkz////+9vT7ysH2h3L0Z071eWL0b1b839n96+f98O76uq72gmz++vn5rqD2lIL3k4HjiW3lAAAABXRSTlMAgOmmHGVdHIUAAACOSURBVDjLjc1JDoMwFMBQCjgdCAU63P+qoCxQkL4Ue/0kd7KbdViHdViHdViHdViHdViHdViHdViHdViHdViHdViHdVhH073+GYCme6QVgLa7bwDEbvrm0z0phY41zfnqCB3T+5AXR+BOWTtiV+RSO0JX5JI+lSN0pW3+URW4OOuwDut66Rik60f3HcZuB7fIEKkcAHNOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/record/selected.png
// module id = +1Ka
// module chunks = 22 26 42